import { render, staticRenderFns } from "./ModalComponent.vue?vue&type=template&id=09b48049&scoped=true"
import script from "./ModalComponent.vue?vue&type=script&lang=ts"
export * from "./ModalComponent.vue?vue&type=script&lang=ts"
import style0 from "./ModalComponent.vue?vue&type=style&index=0&id=09b48049&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b48049",
  null
  
)

export default component.exports